<template>
  <div id ="Equipo">
    <h1>Nuestro Equipo</h1> 

  <v-container class="pa-5 text-center">
    <v-row
      class="fill-height"
      align="center"
      justify="center"
    >
      <template v-for="(item, i) in items">
        <v-col
          :key="i"
          cols="12"
          md="2"
        >
          <v-hover v-slot="{ hover }">
            <v-card
              :elevation="hover ? 12 : 2"
              :class="{ 'on-hover': hover }"
            >
              <v-img
                :src="item.url"
                height="250px" 
              >
                <v-card-title class="text-h6 white--text"> <!--color y estilo del texto interior-->
                  <v-row
                    class="fill-height flex-column"
                    justify="space-between"
                  >
                    <p class="mt-4 subheading text-left">
                      {{ item.title }}
                    </p>

                    <div>
                      <!--<p class="ma-2 text-body-1 font-weight-bold font-italic text-left">
                        {{ item.text }}
                      </p>-->
                      <p class="text-caption font-weight-bold font-italic text-left">
                        {{ item.subtext }}
                      </p>
                    </div>
                    
                    <!--<div class="align-self-center">
                      <v-btn
                        v-for="(icon, index) in icons"
                        :key="index"
                        :class="{ 'show-btns': hover }"
                        :color="transparent"
                        icon
                      >
                        <v-icon
                          :class="{ 'show-btns': hover }"
                          :color="transparent"
                        >
                          {{ icon }}
                        </v-icon>
                      </v-btn>
                    </div>-->
                  </v-row>
                </v-card-title>
              </v-img>
            </v-card>
          </v-hover>
        </v-col>
      </template>
    </v-row>
  </v-container>
  </div>
</template>
    
  <script>
  
  export default {
    data: () => ({
      icons: ['mdi-rewind', 'mdi-play', 'mdi-fast-forward'],
      items: [
        {
          title: 'Maria Cantillo',
          text: " Web Developer",
          subtext: 'Web Developer',
          url:require('../assets/Mercedes.png'),
        },
        {
          title: 'Patricia Chacón',
          text: 'Web Developer',
          subtext: 'Web Developer.',
          url:require('../assets/paty.png'),
        },
        {
          title: 'Gretty Hernandez',
          text: 'Web Developer',
          subtext: 'Web Developer.',
          url:require('../assets/gretty.png'),
        },
        {
          title: 'Angie Pino',
          text: 'Web Developer',
          subtext: 'Web Developer',
          url:require('../assets/angie.png')

        },
        {
          title: 'Diana Llanos',
          text: 'Web Developer',
          subtext: 'Web Developer',
          url:require('../assets/diana.png')

        }

      ],
      transparent: 'rgba(255, 255, 255, 0)',
    }),
  }
</script>
export default {

}

<style scoped>
.v-card {
  transition: opacity .4s ease-in-out;
}

.v-card:not(.on-hover) {
  opacity: 0.6;
 } 



</style>

